import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import Box from '@repo/ui/box'
import Typography from '@repo/ui/typography'

import { TripStepTypeEnum } from '../../../../../lib/types/enums/trip-bookings/trip-step-type.enum'
import { EnrollmentDispatchPlacesType } from '../../../../../lib/types/fields/dispatch-places/dispatch-place'
import { TripBookingDispatchPlaceProperties } from '../../../../../lib/types/models/trip-booking-dispatch-places/trip-booking-dispatch-place.properties'
import { getTravelScheduleTripTypeOption } from '../../../../../lib/utils/functions/travel-schedule.functions'
import { LabelValue } from '.'

type TripStepCardProps = {
  dispatchPlace: EnrollmentDispatchPlacesType
  hasReturnTrip: boolean
}

export function TripStepCard({ dispatchPlace, hasReturnTrip }: TripStepCardProps) {
  const { directionality } = dispatchPlace

  const { date, time, company, transportMeanNumber, carNumber } =
    TripBookingDispatchPlaceProperties.getTripInfo(dispatchPlace)

  const { label, variant } = getTravelScheduleTripTypeOption(directionality, hasReturnTrip)

  const dateLabel =
    directionality === TripStepTypeEnum.INBOUND ? 'Date de départ' : 'Date de retour'

  return (
    <Box className={'border bg-white-hover border-grey-light rounded-lg p-4 flex flex-col gap-4'}>
      <Badge text={`Trajet ${label.toLowerCase()}`} variant={variant} />

      <Box className="flex flex-row gap-2 bg-primary-light rounded p-3 mobile:flex-col tab:flex-col">
        <LabelValue label={dateLabel} color={tailwindColors.grey.lighter}>
          <Badge
            variant={'secondaryRed'}
            text={valueRender(date, (d) => DateFormatter.DDDMYYYY(d))}
          />
        </LabelValue>

        <LabelValue label={'Heure de RDV impérative'} color={tailwindColors.grey.lighter}>
          <Badge
            variant={'secondaryRed'}
            text={valueRender(time, (t) => DateFormatter.HHmm(DateFormatter.createDate(t)))}
          />
        </LabelValue>
      </Box>

      <div className={'flex flex-row gap-2 mobile:flex-col tab:flex-col justify-between'}>
        <LabelValue label={'Compagnie'} color={tailwindColors.grey.lighter}>
          <Typography variant={'tag'}>{valueRender(company)}</Typography>
        </LabelValue>

        <LabelValue label={'N° de vol/train'} color={tailwindColors.grey.lighter}>
          <Typography variant={'tag'}>{valueRender(transportMeanNumber)}</Typography>
        </LabelValue>

        <LabelValue label={'N° de voiture'} color={tailwindColors.grey.lighter}>
          <Typography variant={'tag'}>{valueRender(carNumber)}</Typography>
        </LabelValue>
      </div>
    </Box>
  )
}
